/*
 * FAQ（よくある質問）固有スクリプト
 * Q&Aはページ内に静的マークアップとして書き出し、本スクリプトは
 * カテゴリしぼり込み・キーワード検索の挙動を担当する。
 * アコーディオン開閉自体はSANBY.utils.initQaAccordion（utils.js）に統合した
 * （first-time/category-lpのQ&Aと共通の.qa-list/.qa-item構造を使うため）。
 */
(function (SANBY) {
  let activeCategory = "all";

  function normalize(str) {
    return String(str).toLowerCase();
  }

  function applyFilter() {
    const query = normalize(document.querySelector("[data-faq-search]").value.trim());
    const groups = document.querySelectorAll("[data-faq-category]");
    let visibleTotal = 0;

    groups.forEach((group) => {
      const groupCategory = group.dataset.faqCategory;
      const categoryMatches = activeCategory === "all" || activeCategory === groupCategory;
      let visibleInGroup = 0;

      group.querySelectorAll("[data-qa-item]").forEach((item) => {
        const text = normalize(item.textContent);
        const matches = categoryMatches && (!query || text.includes(query));
        item.hidden = !matches;
        if (matches) visibleInGroup++;
      });

      group.hidden = visibleInGroup === 0;
      visibleTotal += visibleInGroup;
    });

    document.querySelector("[data-faq-empty]").hidden = visibleTotal > 0;
  }

  function initChips() {
    const chips = document.querySelectorAll("[data-faq-filter]");
    chips.forEach((chip) => {
      chip.addEventListener("click", () => {
        activeCategory = chip.dataset.faqFilter;
        chips.forEach((c) => c.classList.toggle("is-active", c === chip));
        applyFilter();
      });
    });
  }

  function initSearch() {
    document.querySelector("[data-faq-search]").addEventListener("input", applyFilter);
  }

  // 他ページ（お問い合わせのサイドバー等）から?category=キーで、該当カテゴリに絞り込んだ状態で開けるようにする
  function applyCategoryParam() {
    const category = new URLSearchParams(window.location.search).get("category");
    if (!category) return;
    const chip = document.querySelector(`[data-faq-filter="${category}"]`);
    if (!chip) return;
    chip.click();
  }

  document.addEventListener("DOMContentLoaded", () => {
    initChips();
    initSearch();
    SANBY.utils.initQaAccordion();
    applyCategoryParam();
  });
})(window.SANBY);
